import { createReducer } from '@ngrx/store';
import { BaseState } from './base.state';

export const baseKey = 'base';
export const initialState: BaseState = {
  transactions: {},

  currentTitle: '',
};

export const BaseReducer = createReducer<BaseState, any>(initialState);
